export default __webpack_public_path__ + "static/media/06.8b9893c5.jpg";